import * as React from 'react';
const SvgPandadoc = (props) => (
  <svg
    width={20}
    height={20}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={20} height={20} rx={6} fill="#248567" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.7305 7.28142L14.6764 7.30847C14.2436 6.95005 13.6823 6.72012 12.9654 6.72012C12.0457 6.72012 11.2004 7.05149 10.6391 7.72099L11.5114 8.64747C11.9443 8.23495 12.4041 8.00502 12.9925 8.00502C14.0948 8.03207 14.8049 8.8774 14.8049 10.0135C14.8049 11.1496 14.061 12.022 12.9384 12.022C10.1251 12.022 10.9163 6.72689 7.13602 6.72689C5.24249 6.72689 3.91701 8.14028 3.91701 10.0203V15.755H5.26954V12.6915L5.32364 12.6645C5.75645 13.0229 6.31775 13.2528 7.03458 13.2528C7.9543 13.2528 8.79963 12.9215 9.36093 12.252L8.48855 11.3255C8.05574 11.738 7.59588 11.9679 7.00753 11.9679C5.90523 11.9409 5.19515 11.0955 5.19515 9.95942C5.19515 8.8233 5.93904 7.95092 7.06164 7.95092C9.87489 7.95092 9.08366 13.2461 12.864 13.2461C14.7575 13.2461 16.083 11.8327 16.083 9.95266V4.245H14.7305V7.28142Z"
      fill="white"
    />
  </svg>
);
export default SvgPandadoc;
